<ng-container *ngIf="order$ | async as order">
  <button
    *ngIf="order.isB2BOrder"
    sdButton
    class="button-download-bill"
    type="accent"
    size="m"
    [disabled]="loading$ | async"
    (click)="onClickButtonBill(order)"
  >
    Скачать счёт
  </button>
</ng-container>
